import React, { useEffect } from 'react';
import './proveedores.css';

const Proveedores  = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='container transparencia-container container-mh'>
      <div className='row'>
        <div className='col-12'>
          <h1 className='title'>Padrón de Proveedores</h1>
          <hr className='hr-gob'/>
        </div>

        <div className='col-md-4 col-12 ofiprov-card'>
          <img src="/assets/imgs/proveedores/Requisitos Proveedor Ampliación.png" alt="Proveedores y Contratistas" className='ofiprov-img' />
          <h2 className='ofiprov-subtitle'>Requisitos Proveedor Ampliación</h2>
          <div className='ofiprov-links'>
            <a href="https://s-contraloria.hidalgo.gob.mx/interes/contra_proveedores/julio/REQUISITOS PROVEEDOR MODIFICACIÓN OFICINA VIRTUAL.pdf" target="_blank" rel="noopener noreferrer" 
            className='btn-oficina'>Ir al Servicio</a>
            {/* <a href="https://ruts.hidalgo.gob.mx/ver/392" target="_blank" rel="noopener noreferrer" className='btn-oficina'>Requisitos</a> */}
            {/* <span className='btn-oficina btn-oficina--red'>Video Tutorial</span> */}
          </div>
        </div>


          <div className='col-md-4 col-12 ofiprov-card'>
          <img src="/assets/imgs/proveedores/Requisitos proveedor cambio de accionistas.png" alt="Sancionados" className='ofiprov-img' />
          <h2 className='ofiprov-subtitle'>Requisitos Proveedor Cambio de Accionistas</h2>
          <div className='ofiprov-links'>
            <a href="https://s-contraloria.hidalgo.gob.mx/interes/REQUISITOS%20PROVEEDOR%20O%20CONTRATISTA%20CAMBIO%20DE%20ACCIONISTAS-junio.pdf" target="_blank" rel="noopener noreferrer" 
            className='btn-oficina'>Ir al Servicio</a>
            {/* <a href="https://ruts.hidalgo.gob.mx/ver/1602" target="_blank" rel="noopener noreferrer" className='btn-oficina'>Requisitos</a>
            <span className='btn-oficina btn-oficina--red'>Video Tutorial</span> */}
          </div>
        </div>


        <div className='col-md-4 col-12 ofiprov-card'>
          <img src="/assets/imgs/proveedores/Requisitos proveedor inscripción.png" alt="Proveedores" className='ofiprov-img' />
          <h2 className='ofiprov-subtitle'>Requisitos Proveedor Inscripción</h2>
          <div className='ofiprov-links'>
            
             <a href="https://s-contraloria.hidalgo.gob.mx/interes/contra_proveedores/julio/REQUISITOS PROVEEDOR INSCRIPCION OFICINA VIRTUAL.pdf" target="_blank" rel="noopener noreferrer" 
           

        
           className='btn-oficina'>Ir al Servicio</a>
            {/* <a href="https://ruts.hidalgo.gob.mx/ver/409" target="_blank" rel="noopener noreferrer" className='btn-oficina'>Requisitos</a>
            <span className='btn-oficina btn-oficina--red'>Video Tutorial</span>  */}
          </div>
        </div>


        <div className='col-md-4 col-12 ofiprov-card'>
         <img src="/assets/imgs/proveedores/Aviso de Privacidad Simplificado.png" alt="Proveedores" className='ofiprov-img' />
          <h2 className='ofiprov-subtitle'>Aviso de Privacidad Simplificado</h2>
          <div className='ofiprov-links'>
            
             <a href="/interes/contra_proveedores/julio/AVISO DE PRIVACIDAD SIMPLIFICADO.docx" target="_blank" rel="noopener noreferrer" 
           

        
           className='btn-oficina'>Ir al Servicio</a>
            {/* <a href="https://ruts.hidalgo.gob.mx/ver/409" target="_blank" rel="noopener noreferrer" className='btn-oficina'>Requisitos</a>
            <span className='btn-oficina btn-oficina--red'>Video Tutorial</span>  */}
          </div>
        </div>


        <div className='col-md-4 col-12 ofiprov-card'>
          <img src="/assets/imgs/proveedores/Carta bajo protesta de decir verdad socio.png" alt="Proveedores" className='ofiprov-img' />
          <h2 className='ofiprov-subtitle'>Carta Bajo Protesta de Decir Verdad Socio</h2>
          <div className='ofiprov-links'>
            
             <a href="/interes/contra_proveedores/julio/CARTA BAJO PROTESTA DE DECIR VERDAD SOCIO.docx" target="_blank" rel="noopener noreferrer" 
           

        
           className='btn-oficina'>Ir al Servicio</a>
            {/* <a href="https://ruts.hidalgo.gob.mx/ver/409" target="_blank" rel="noopener noreferrer" className='btn-oficina'>Requisitos</a>
            <span className='btn-oficina btn-oficina--red'>Video Tutorial</span>  */}
          </div>
        </div>


         <div className='col-md-4 col-12 ofiprov-card'>
          <img src="/assets/imgs/proveedores/Carta bajo protesta de decir verdad representante legal.png" alt="Proveedores" className='ofiprov-img' />
          <h2 className='ofiprov-subtitle'>Carta bajo protesta de decir verdad representante legal </h2>
          <div className='ofiprov-links'>
            
             <a href="/interes/contra_proveedores/julio/CARTA BAJO PROTESTA DE DECIR VERDAD REPRESENTANTE LEGAL.docx" target="_blank" rel="noopener noreferrer" 
           

        
           className='btn-oficina'>Ir al Servicio</a>
            {/* <a href="https://ruts.hidalgo.gob.mx/ver/409" target="_blank" rel="noopener noreferrer" className='btn-oficina'>Requisitos</a>
            <span className='btn-oficina btn-oficina--red'>Video Tutorial</span>  */}
          </div>
        </div>


        <div className='col-12 ofiprov-contact'>
          <div className='ofiprov-contact-box'>
            <p>Para cualquier consulta, ponemos a su disposición los siguientes medios de contacto en horario laboral, de 9:00 a.m. a 5:00 p.m.:</p>
            <p><strong>Correo electrónico:</strong> <a href="mailto:agenda.padron@hidalgo.gob.mx">agenda.padron@hidalgo.gob.mx</a></p>
        
          </div>
        </div>
      </div>
    </div>
  )
}

export default Proveedores ;
